import firebase from "firebase/app";
import "firebase/functions";
import "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCRxrn153GRHcALAcc6z9SosKY3x0fmvxE",
  authDomain: "cube-soft.firebaseapp.com",
  databaseURL: "https://cube-soft.firebaseio.com",
  projectId: "cube-soft",
  storageBucket: "cube-soft.appspot.com",
  messagingSenderId: "799349412470",
  appId: "1:799349412470:web:492eb658b844152f"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
const db = firebase.firestore();
export const fcn = firebase.functions();

// db.settings({ timestampsInSnapshots: true });
export default db;
